import React from "react";

const coverFlow = () => {

    return(
        <div style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            width:"100%"
        }}>
           
           <h2>Cover Flow</h2>

        </div>
    )
}

export default coverFlow